import React from 'react';
import { router } from '@forge/bridge';

import { OptionTranslated, SelectTranslated } from '../components/edit/FieldSelect';
import { LangCodes, LevelsInfo } from '../interfaces';
import { Label, SelectDescription } from '../styles';

import {
    IS_IN_SELECT_CONTEXT,
    LEFT_BRACKET_CHAR,
    LEVEL_DESCRIPTION_KEY,
    LEVEL_DESCRIPTION_TRANSLATION_KEY,
    LEVEL_INFO_DESCRIPTION_LINK_REGEX,
    LEVEL_NAME_KEY,
    LEVEL_NAME_TRANSLATION_KEY,
    PIPE_CHAR,
    RIGHT_BRACKET_CHAR,
} from './constants';
import { getOptionLabel } from './levelModelUtils';

const renderLevelInfoDescription = (description: string, levelInfoData: OptionTranslated, locale: LangCodes | undefined) => {
    const textArray = [...description.matchAll(new RegExp(LEVEL_INFO_DESCRIPTION_LINK_REGEX, 'g'))];
    if (textArray.length === 0 || !textArray.some(link => link[1])) {
        return (
            <SelectDescription topMargin='4px'>{getOptionLabel(levelInfoData, locale, IS_IN_SELECT_CONTEXT)}</SelectDescription>
        );
    }

    return (
        <SelectDescription topMargin='4px'>
            {textArray.map(text => {
                const match = text[0];
                const link = match.substring(match.indexOf(PIPE_CHAR) + 1, match.indexOf(RIGHT_BRACKET_CHAR));
                return text[3] ?
                        <span>{text[3]}</span>
                    :   <a
                            onClick={e => {
                                e.preventDefault();
                                router.open(link);
                            }}
                            href={link}
                        >
                            {match.substring(match.indexOf(LEFT_BRACKET_CHAR) + 1, match.indexOf(PIPE_CHAR))}
                        </a>;
            })}
        </SelectDescription>
    );
};

export const getLevelInfoIfExists = (
    displayedSelect: SelectTranslated,
    chosenValues: Map<string, OptionTranslated>,
    levelsInfo: LevelsInfo,
    locale: LangCodes | undefined,
    isLevelNameSearch = true
): JSX.Element => {
    const currentLevelInfos = levelsInfo[`${displayedSelect.name}`];
    const displayedSelectFirstOptionKey = displayedSelect.options[0].value;
    const matchingLevelInfo = currentLevelInfos.find(option => option.firstOptionKey === displayedSelectFirstOptionKey);

    if (matchingLevelInfo) {
        const levelInfoText = {
            translation:
                isLevelNameSearch ?
                    matchingLevelInfo.levelInfo[LEVEL_NAME_TRANSLATION_KEY]
                :   matchingLevelInfo.levelInfo[LEVEL_DESCRIPTION_TRANSLATION_KEY],
            label:
                isLevelNameSearch ?
                    matchingLevelInfo.levelInfo[LEVEL_NAME_KEY]
                :   matchingLevelInfo.levelInfo[LEVEL_DESCRIPTION_KEY],
            value: '',
        };

        return isLevelNameSearch ?
                <Label bottomMargin='4px'>{getOptionLabel(levelInfoText, locale, IS_IN_SELECT_CONTEXT)}</Label>
            :   renderLevelInfoDescription(getOptionLabel(levelInfoText, locale, IS_IN_SELECT_CONTEXT), levelInfoText, locale);
    }

    return <></>;
};
